"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mark;

var _markRegExp = _interopRequireDefault(require("./markRegExp"));

var _markTerm = _interopRequireDefault(require("./markTerm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Replaces matching patterns in a string with markers.
 *
 * @param {string | React.ReactNodeArray} content The content to parse and mark.
 *
 * @param {string | RegExp} rule The pattern to search and replace in the
 * content.
 *
 * @param {Function} tag A function that takes the match string and must return
 * a React element. The value returned by that function will
 * replace the term in the output.
 *
 * @param {number} matchIndex The index of the match to use when marking with
 * a RegExp. If not provided, will use the last non-null match available.
 *
 * @returns {React.ReactNodeArray} A ReactNodeArray of strings and components,
 * similar to the original content but where each matching pattern has been
 * replaced by a marking component.
 */
function mark(content, rule, tag, matchIndex) {
  var _ref;

  if (!Array.isArray(content)) {
    content = [content];
  }

  if (!(rule instanceof RegExp || typeof rule === 'string')) {
    throw Error('Unsupported rule type for rule `' + rule + '`.');
  }

  var output = [];

  var _iterator = _createForOfIteratorHelper(content),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (typeof part === 'string') {
        var marked = void 0;

        if (rule instanceof RegExp) {
          marked = (0, _markRegExp["default"])(part, rule, tag, matchIndex);
        } else {
          marked = (0, _markTerm["default"])(part, rule, tag);
        }

        output.push(marked);
      } else {
        output.push(part);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return (_ref = []).concat.apply(_ref, output);
}